module.exports = __webpack_public_path__ + "img/w3_trash_solid_recover_dark.ed94a6df.png";